/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Make_An_EnquiryInputs */

const en_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make an Enquiry`)
};

const es_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz una consulta`)
};

const fr_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire une demande`)
};

const de_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Anfrage stellen`)
};

const ja_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問い合わせる`)
};

const zh_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发起咨询`)
};

const ar_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أرسل استفساراً`)
};

const id_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Pertanyaan`)
};

const it_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai una Richiesta`)
};

const ru_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сделать запрос`)
};

const pt_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma Consulta`)
};

const ko_make_an_enquiry = /** @type {(inputs: Make_An_EnquiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`질문 남기기`)
};

/**
* | output |
* | --- |
* | "Make an Enquiry" |
*
* @param {Make_An_EnquiryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const make_an_enquiry = /** @type {((inputs?: Make_An_EnquiryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Make_An_EnquiryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_make_an_enquiry(inputs)
	if (locale === "es") return es_make_an_enquiry(inputs)
	if (locale === "fr") return fr_make_an_enquiry(inputs)
	if (locale === "de") return de_make_an_enquiry(inputs)
	if (locale === "ja") return ja_make_an_enquiry(inputs)
	if (locale === "zh") return zh_make_an_enquiry(inputs)
	if (locale === "ar") return ar_make_an_enquiry(inputs)
	if (locale === "id") return id_make_an_enquiry(inputs)
	if (locale === "it") return it_make_an_enquiry(inputs)
	if (locale === "ru") return ru_make_an_enquiry(inputs)
	if (locale === "pt") return pt_make_an_enquiry(inputs)
	return ko_make_an_enquiry(inputs)
});